import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { StoplossRoutingModule } from './stoploss-routing.module';
import { StoplossPesquisaComponent } from './stoploss-pesquisa/stoploss-pesquisa.component';
import { StoplossListagemComponent } from './stoploss-listagem/stoploss-listagem.component';


@NgModule({
  declarations: [StoplossPesquisaComponent, StoplossListagemComponent],
  imports: [
    SharedModule,
    CommonModule,
    StoplossRoutingModule,
  ]
})
export class StoplossModule { }
